import React from 'react';
import { render } from 'react-dom';

class Address extends React.Component {
    render() {
        return (
            <div>
                <div>{this.props.name}</div>
                <div>
                    {this.props.streetAddress1} {this.props.streetAddress2}
                    {this.props.city}, {this.props.state} {this.props.zipCode}
                </div>
            </div>
        );
    }
}

export default Address;  